export const K = {
  bg: "#F5F7FA", bg1: "#FFFFFF", bg2: "#F0F2F5", bg3: "#E8EBF0",
  s: "#FFFFFF", sh: "#F5F7FA",
  b0: "#E5E7EB", b1: "#D1D5DB", b2: "#C0C5CF",
  t0: "#0B1220", t1: "#1F2937", t2: "#475569", t3: "#64748B",
  p: "#2563EB", pl: "#3B82F6", pg: "rgba(37,99,235,.08)", pb: "rgba(37,99,235,.15)",
  g: "#10B981", gb: "rgba(16,185,129,.08)", gd: "rgba(16,185,129,.15)",
  r: "#EF4444", rb: "rgba(239,68,68,.08)", rd: "rgba(239,68,68,.15)",
  a: "#F59E0B", ab: "rgba(245,158,11,.08)", ad: "rgba(245,158,11,.15)",
  bl: "#3B82F6", blb: "rgba(59,130,246,.08)",
  pu: "#8B5CF6", pub: "rgba(139,92,246,.08)",
  tl: "#14B8A6", ro: "#EC4899", cy: "#06B6D4",
  pill: 999,
};

export const FT = "'Plus Jakarta Sans',system-ui,sans-serif";
